import {EventEmitter} from 'events';
import Router from 'vanilla-router';
import Viewport from "./components/Viewport";
import Intro from './components/Intro';
import Interactive from './components/Interactive';
import {Power4, TweenMax} from "gsap";
import {Navigation} from "./components/Navigation";

// This needs to be generated by WP / PHP
// if (!window._SERVER) window._SERVER = 'http://roofdesigner.local/wp-content/themes/tricore'
// << it is.

export class interactivesites extends Router {

    constructor() {
        super();
        let self = this;
        console.log('%c TRICORE / FLETCHER STEEL +++ INTERACTIVESITES NEW ZEALAND +++ WWW VERSION 1.1 (hf)', 'background: #222; color: #bada55');

        // TODO: install service worker?


        // Viewport
        this.viewport = new Viewport();
        this.navigation = new Navigation(this.viewport);
        this.unmuted = false;           // This flag is driven by user interaction

        // Show viewport
        $$('body').css('opacity', 1);
        // New Intro
        this.intro = new Intro(this.viewport);

        let video = document.getElementById('video_intro');

        /**
         * Once meta data is loaded, attempt to play
         */
        video.addEventListener('loadedmetadata', () => {
            // if (video.buffered.length === 0) return;
            try {
                let bufferedSeconds = video.buffered.end(0) - video.buffered.start(0);
                // console.log(bufferedSeconds + ' seconds of video are ready to play!');
            } catch(e) {
                console.warn('No valid buffer data')
            }

            video.oncanplaythrough = function () {
                // console.info('Intro can play through')
                self.startApp();
            };


            video.play().then(
                _ => {
                    video.pause()
                    // console.info('Intro video initiated')
                },
                _ => {
                    // Note: This is not necessary anymore: We mute all videos by default
                    console.warn('AUTOPLAY NOT POSSIBLE')
                    this.showUserInteractionButton();
                }
            );


            // Add videos to buffer
            // $$('body').append(`<video class="video_buffer" style="display: none;" src="/assets/videos/02_Transition.mp4" webkit-playsinline="true" playsinline="true" preload="auto" muted></video>`)
            // $$('body').append(`<video class="video_buffer" style="display: none;" data-command="03_PreFinished_Lining_Sheet" src="/assets/videos/03_PreFinished_Lining_Sheet.mp4" webkit-playsinline="true" playsinline="true" preload="metadata" muted></video>`)
            // $$('body').append(`<video class="video_buffer" style="display: none;" data-command="04_Insulation" src="/assets/videos/04_Insulation.mp4" webkit-playsinline="true" playsinline="true" preload="metadata" muted></video>`);
            // $$('body').append(`<video class="video_buffer" style="display: none;" data-command="05_Underlay" src="/assets/videos/05_Underlay.mp4" webkit-playsinline="true" playsinline="true" preload="metadata" muted></video>`)
            // $$('body').append(`<video class="video_buffer" style="display: none;" data-command="06_Fastening" src="/assets/videos/06_Fastening.mp4" webkit-playsinline="true" playsinline="true" preload="metadata" muted></video>`)
            // $$('body').append(`<video class="video_buffer" style="display: none;" data-command="07_Roof_Sheet" src="/assets/videos/07_Roof_Sheet.mp4" webkit-playsinline="true" playsinline="true" preload="metadata" muted></video>`)

            // Full preload of videos (attempt):
            let vlen = $$('.video_buffer').length
            console.log('Filling ' + vlen + ' video buffers ')
            $$('.video_buffer').each((i, v) => {
                v.play().then(_ => {
                    v.pause()
                })
            });
        })


        // DEV:
        // Load main video, show button and wait for user interaction
        // TweenLite.set('#intro_btn', {y:'110vh'});
        // $$('#ovl_load').remove()
        // this.interactive = new Interactive(this.viewport, this.navigation);
        //
        // this._addEvents();
        // this.controlsIn()
        // this.interactive.go()
        // })

    }

    showUserInteractionButton() {
        let self = this;
        this.noAutoplay = true;
        TweenMax.to('#start-btn', 1, {delay: 3, display: "block", alpha: 1});
        TweenMax.to('#ovl-load-loading', 0.8, {delay: 3, display: "none", alpha: 0});
        TweenMax.to('#triangle', 0.8, {delay: 3, display: "none", alpha: 0});
        $$('#start-btn').on('click', () => {
            self.startApp();
        })

    }

    startApp() {

        let tlA = new TimelineMax();
        tlA.to('#ovl-loader polygon', 0.3, {strokeDasharray: 0})
            .to('#ovl-loader polygon', 0.3, {attr: {points: "120,0 120,0 120,96 120,96"}, ease: Power4.easeOut})
            .to('#ovl-load-loading', 0.3, {alpha: 0})
            .to('#ovl-loader polygon', 0.8, {
                delay: 0.2,
                attr: {points: "-2,0 242,0 "},
                strokeDasharray: 0,
                ease: Power4.easeInOut
            })
            .to('#ovl-loader .screen', 0.1, {
                background: '#ffffff',  //9A171C
                height: '100vh',
                ease: Power4.easeInOut
            })
            .to('#ovl-loader .screen', 0.6, {
                background: 'rgba(255,255,255,1)',
                height: 2,
                ease: Power4.easeInOut
            })
            .to('#ovl-loader .screen', 0.4, {width: 2, alpha: 0, ease: Power4.easeInOut})
            .call(() => {
                this.intro.play()
            })
            .set('#ovl-loader', {"display": "none"})
            .set('#ovl_load', {"display": "none"})

        // });

        this.intro.on('ended', () => {
            // Hide intro video DOM
            TweenMax.set('#video_intro', {alpha: 0, "display": "none"})
        })

        this.intro.on('action', () => {
            console.info('INTRO ACTION')
            // Remove Intro
            // intro = null;
            // Load the next class, show the main player
            this.interactive = new Interactive(this.viewport, this.navigation);
            this._addEvents();

            // Start other video
            this.interactive.go();

        })
    }


// ------------------------------------------------------------------------------------------------
// Public
// ------------------------------------------------------------------------------------------------


    controlsIn() {
        // Hide white logo
        TweenMax.to('#logo_white', 0.4, {display: 'none', alpha: 0})

        let _speed = 2;
        TweenMax.to('.animate.left', _speed, {x: "0", ease: Power4.easeOut});
        TweenMax.to('.animate.right', _speed, {x: "0", ease: Power4.easeOut});
        TweenMax.to('.animate.top', _speed, {y: "0", ease: Power4.easeOut});
        TweenMax.to('.animate.bottom', _speed, {y: "0vh", ease: Power4.easeOut})
        // Home button
        TweenMax.to('#homeLink', 0.4, {display: "block", alpha: 1, ease: Power4.easeOut})
        // Support link
        TweenMax.to('#support__link', _speed, {y: "0vh", display: "block", alpha: 1, ease: Power4.easeOut})

    }

    controlsOut() {
        let _speed = 3.4;
        TweenMax.to('.animate.left', _speed, {x: "-20vw", ease: Power4.easeOut});
        TweenMax.to('.animate.right', _speed, {x: "20vw", ease: Power4.easeOut});
        TweenMax.to('.animate.top', _speed, {y: "-20vh", ease: Power4.easeOut});
        TweenMax.to('.animate.bottom', _speed, {y: "20vh", ease: Power4.easeOut})
        // Home button
        TweenMax.to('#homeLink', 0.4, {display: "none", alpha: 0, ease: Power4.easeOut})
        // Support link
        TweenMax.to('#support__link', _speed, {y: "+=100px", display: "none", alpha: 0, ease: Power4.easeOut})
    }

    controlsToggleDisable(state) {
        if (!state) {
            $$('.animate.left').addClass('disabled');
            $$('.animate.right').addClass('disabled');
            $$('.animate.top').addClass('disabled');
            $$('.animate.bottom').addClass('disabled');
        } else {
            $$('.animate.left').removeClass('disabled');
            $$('.animate.right').removeClass('disabled');
            $$('.animate.top').removeClass('disabled');
            $$('.animate.bottom').removeClass('disabled');
        }
    }


    _addEvents() {

        // Interactive
        this.interactive.on('main:ended', () => {
            this._addEvents();
            this.controlsIn()
        })

        // Interactive component is ready to go.
        // THIS IS NOT WORKING ANYMORE AS WE USER A PRELOADED VIDEO TAG
        this.interactive.on('ready', () => {
            console.log('INTERACTIVE READY')
            // // Start other video
            // this.interactive.go();
            // // Hide intro video DOM
            // TweenMax.set('#video_intro', {alpha: 0, "display": "none"})
        });

        // A video has become ready to rock
        this.interactive.on('video:active', (to) => {
            if (to === 'main') this._setActiveVideoUI('main', 'child');
            else this._setActiveVideoUI('child', 'main');
        });

        // A child video has started playing
        this.interactive.on('child:start', () => {
            // Close any overlays :: NOTE: this should not be required as buttons are disabled
            this.navigation.hideAllOverlays();
            // Hide controls
            this.controlsOut();
        });

        //TODO: clean up
        // Watch overlay inline videos
        let video_cs = document.getElementById('video_cs');
        if (video_cs) {
            video_cs.addEventListener('ended', () => {
                //
                TweenMax.to('#ovl_specs video', 2, {
                    opacity: 0, onComplete: () => {
                        this.navigation.hideAllOverlays()
                    }
                })
                // setTimeout(() => {
                //     this.navigation.hideAllOverlays()
                // }, 1000)
            });
        }

        // Request to show or hide controls
        this.interactive.on('controls', (on) => {
            if (on) this.controlsIn(); else this.controlsOut();
        });


        // WHEN an overlay has become visible
        // No need to re-hook slider for a single pa
        this.navigation.on('nav:overlay_active', () => {
            // Disable controls
            // TODO: may be too late
            this.controlsToggleDisable(false);
            // Autoplay video TODO: remove logic, just temporary!
            let v = document.getElementById('video_cs');
            v.play().then((e) => {
            });
        });
        this.navigation.on('nav:overlay_inactive', () => {
            // Disable controls
            this.controlsToggleDisable(true);
            this.interactive.stopAll();
        });

        this.navigation.on('reload', () => {
            window.location.reload();
        });

    }

    _setActiveVideoUI(state, oldState) {
        console.log('SET VIDEO UI', state)
        $$('#video_' + state).css('z-index', 1)
        $$('#video_' + oldState).css('z-index', -1)
        // TweenMax.set('#video_' + state, {zIndex: 1});
        // TweenMax.set('#video_' + oldState, {zIndex: -1})
        // TweenMax.set('#canvas_' + state, {zIndex: 1});
        // TweenMax.set('#canvas_' + oldState, {zIndex: -1})
    }


}

/**
 * Initialise on window ready
 * CHECK OUT: https://framework7.io/docs/init-app.html
 */
document.addEventListener("DOMContentLoaded", function () {
    new interactivesites();
});
